import plainTextToHtml from './utils/plaintexttohtml';
import normalizeClipboardHtml from './utils/normalizeclipboarddata';

const decodeContent = content => {
    content._children?.forEach(el => {
        if (el.name === 'a') {
            el._attrs.set('href', decodeURI(el._attrs.get('href')));
        }
        decodeContent(el);
    });
};

export default class ClipboardLinksDecode {
    static get pluginName() {
		return 'ClipboardLinksDecode';
	}

    constructor(editor) {
        const editingView = editor.editing.view;

        editingView.document.on('clipboardInput', (evt, data) => {
            const { dataTransfer } = data;
			let { content = '' } = data;

			if (!content) {
				if (dataTransfer.getData('text/html') ) {
					content = normalizeClipboardHtml(dataTransfer.getData('text/html'));
				} else if ( dataTransfer.getData('text/plain') ) {
					content = plainTextToHtml(dataTransfer.getData('text/plain'));
				}
			}

            content = editor.data.processor.toView(content);
            decodeContent(content);


            content.data = content;
            editingView.scrollToTheSelection();
        });
    }
}
